(() => {
  const STORAGE_KEY = 'renao:wishlist:v1';
  const selectors = {
    toggle: '[data-wishlist-toggle]',
    count: '[data-wishlist-count]',
    grid: '[data-wishlist-grid]',
    empty: '[data-wishlist-empty]',
    total: '[data-wishlist-total]',
    remove: '[data-wishlist-remove]',
  };

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  };

  const getProductFromButton = (button) => ({
    id: String(button.dataset.productId || button.dataset.productHandle || ''),
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '#',
    image: button.dataset.productImage || '',
    price: button.dataset.productPrice || '',
    comparePrice: button.dataset.productComparePrice || '',
    variantId: button.dataset.variantId || '',
  });

  const escapeHTML = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => {
      const entities = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };
      return entities[char];
    });

  const sameProduct = (item, product) =>
    item.id === String(product.id) || (item.handle && product.handle && item.handle === product.handle);

  const isWishlisted = (product) => readWishlist().some((item) => sameProduct(item, product));

  const updateCounts = () => {
    const count = readWishlist().length;
    document.querySelectorAll(selectors.count).forEach((node) => {
      node.textContent = count;
      node.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll(selectors.total).forEach((node) => {
      node.textContent = count;
    });
  };

  const updateButtons = () => {
    document.querySelectorAll(selectors.toggle).forEach((button) => {
      const active = isWishlisted(getProductFromButton(button));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  };

  const toggleWishlist = (button) => {
    const product = getProductFromButton(button);
    if (!product.id) return;

    const items = readWishlist();
    const exists = items.some((item) => sameProduct(item, product));
    const nextItems = exists ? items.filter((item) => !sameProduct(item, product)) : [product, ...items];

    writeWishlist(nextItems);
    renderWishlistPage();
    updateCounts();
    updateButtons();
  };

  const productCardMarkup = (product) => {
    const title = escapeHTML(product.title);
    const price = escapeHTML(product.price);
    const compare = escapeHTML(product.comparePrice);
    const url = escapeHTML(product.url);
    const imageUrl = escapeHTML(product.image);
    const comparePrice = product.comparePrice
      ? `<s class="renao-wishlist-card__compare">${compare}</s>`
      : '';
    const image = product.image
      ? `<img src="${imageUrl}" alt="${title}" loading="lazy">`
      : '<div class="renao-wishlist-card__placeholder"></div>';

    return `
      <article class="renao-wishlist-card" data-wishlist-item="${product.id}">
        <a class="renao-wishlist-card__media" href="${url}">
          ${image}
        </a>
        <button class="renao-wishlist-card__heart is-active" type="button" data-wishlist-remove="${product.id}" aria-label="Remove from wishlist">
          ${heartIcon()}
        </button>
        <div class="renao-wishlist-card__content">
          <a class="renao-wishlist-card__title" href="${url}">${title}</a>
          <div class="renao-wishlist-card__prices">
            ${comparePrice}
            <span>${price}</span>
          </div>
          <a class="renao-wishlist-card__button button button--primary" href="${url}">
            Personalize Product
          </a>
        </div>
      </article>
    `;
  };

  const heartIcon = () => `
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 20.6S4.5 16.2 2.4 10.6C1.1 7.1 3.4 4 6.9 4c2 0 3.7 1 5.1 2.9C13.4 5 15.1 4 17.1 4c3.5 0 5.8 3.1 4.5 6.6C19.5 16.2 12 20.6 12 20.6Z"/>
    </svg>
  `;

  const moneyRegex = /(?:₺\s?[\d.,]+|[\d.,]+\s?(?:TL|₺))/gi;

  const extractProductHandle = (url) => {
    try {
      const parsed = new URL(url, window.location.origin);
      const match = parsed.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (error) {
      return '';
    }
  };

  const extractPrices = (text) => {
    const matches = String(text || '').match(moneyRegex) || [];
    return {
      comparePrice: matches.length > 1 ? matches[0] : '',
      price: matches[matches.length - 1] || '',
    };
  };

  const findCustomCard = (link) => {
    const candidates = [
      link.closest('.product-card-wrapper'),
      link.closest('.grid__item'),
      link.closest('article'),
      link.closest('li'),
      link.closest('[class*="product"]'),
      link.closest('[class*="card"]'),
    ].filter(Boolean);

    return candidates.find((candidate) => {
      if (candidate.querySelector(selectors.toggle)) return false;
      if (candidate.closest('header, .menu-drawer, .quick-add-modal, .product__info-wrapper')) return false;
      return candidate.querySelector('img') && candidate.textContent.trim().length > 8;
    });
  };

  const enhanceCustomCards = () => {
    document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const card = findCustomCard(link);
      if (!card) return;

      const handle = extractProductHandle(link.href);
      if (!handle) return;

      const image = card.querySelector('img');
      const titleNode = card.querySelector('h1, h2, h3, .card__heading, [class*="title"]');
      const prices = extractPrices(card.textContent);
      const title = (titleNode?.textContent || link.textContent || image?.alt || 'Product').trim();

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'renao-wishlist-button';
      button.dataset.wishlistToggle = '';
      button.dataset.productId = `handle:${handle}`;
      button.dataset.productHandle = handle;
      button.dataset.productTitle = title;
      button.dataset.productUrl = link.href;
      button.dataset.productImage = image?.currentSrc || image?.src || '';
      button.dataset.productPrice = prices.price;
      button.dataset.productComparePrice = prices.comparePrice;
      button.setAttribute('aria-label', 'Add to wishlist');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = `${heartIcon()}<span class="visually-hidden">Add to wishlist</span>`;

      card.classList.add('renao-wishlist-enhanced-card');
      card.appendChild(button);
    });
  };

  function renderWishlistPage() {
    const grid = document.querySelector(selectors.grid);
    if (!grid) return;

    const empty = document.querySelector(selectors.empty);
    const items = readWishlist();

    grid.innerHTML = items.map(productCardMarkup).join('');
    grid.toggleAttribute('hidden', items.length === 0);
    if (empty) empty.toggleAttribute('hidden', items.length > 0);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(selectors.toggle);
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(toggle);
      return;
    }

    const remove = event.target.closest(selectors.remove);
    if (remove) {
      const id = String(remove.dataset.wishlistRemove || '');
      writeWishlist(readWishlist().filter((item) => item.id !== id));
      renderWishlistPage();
      updateCounts();
      updateButtons();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    enhanceCustomCards();
    renderWishlistPage();
    updateCounts();
    updateButtons();
  });

  document.addEventListener('shopify:section:load', () => {
    enhanceCustomCards();
    renderWishlistPage();
    updateCounts();
    updateButtons();
  });
})();
